var exports = {
  "ZO": "MessageContextPrefix.module__channelHeader___X2lGSH",
  "wO": "MessageContextPrefix.module__channelHeaderCompact___X2lGSH",
  "p": "MessageContextPrefix.module__channelIcon___X2lGSH",
  "uS": "MessageContextPrefix.module__channelIconAvatar___X2lGSH",
  "bR": "MessageContextPrefix.module__channelIconAvatarImage___X2lGSH",
  "D4": "MessageContextPrefix.module__channelNameButton___X2lGSH",
  "Kw": "MessageContextPrefix.module__channelNameText___X2lGSH",
  "Vf": "MessageContextPrefix.module__channelNamePrimary___X2lGSH",
  "S4": "MessageContextPrefix.module__channelScopeRow___X2lGSH",
  "AQ": "MessageContextPrefix.module__channelScopeGuildIcon___X2lGSH",
  "oN": "MessageContextPrefix.module__channelScopeGuildName___X2lGSH",
  "V$": "MessageContextPrefix.module__channelScopeChevron___X2lGSH",
  "fm": "MessageContextPrefix.module__channelScopeChannelInfo___X2lGSH",
  "Gn": "MessageContextPrefix.module__channelScopeChannelIcon___X2lGSH",
  "wF": "MessageContextPrefix.module__channelScopeChannelName___X2lGSH",
  "bo": "MessageContextPrefix.module__focusRingTight___X2lGSH",
};

module.exports = exports;
